import type { FetchProductDescriptionsEpicApi } from 'epic/productDescriptions/fetchProductDescriptionsEpic';
import { map } from 'rxjs/operators';
import type { ProductDescriptionResult } from 'state/product-description/model';
import type { IHttpClient } from 'utils/http/httpClient.model';

type ProductDescriptionsApi = FetchProductDescriptionsEpicApi;
export function productDescriptionsApiConnector(httpClient: IHttpClient): ProductDescriptionsApi {
  return {
    getProductDescriptions() {
      return httpClient
        .getJSON<ProductDescriptionResult>({
          url: 'api/v2/product-descriptions',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
